"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
var csod = require("player-core");
var application_1 = require("../models/application");
var application_2 = require("../models/application");
var application_3 = require("../models/application");
var ApplicationActions_1 = require("../actions/ApplicationActions");
var UrlHelper_1 = require("../shared/code/UrlHelper");
var CareerSiteHeaderFooterDataProvider_1 = require("player-career-site-header-footer/shared/provider/CareerSiteHeaderFooterDataProvider");
var ReferralTokenHelper_1 = require("../shared/code/ReferralTokenHelper");
var ApiService = (function () {
    function ApiService() {
        this.serviceBase = csod.context.serviceBase;
        this.baseUrl = this.serviceBase + "services/x/career-site";
        this.requisitionBaseUrl = this.serviceBase + "services/x/job-requisition";
        this.jobApplicationBaseUrl = this.serviceBase + "services/x/application/v1/progress";
        this.userId = csod.context.user;
        this.corp = csod.context.corp;
        this.corpSettingsBaseUrl = this.serviceBase + "services/x/corpsettings";
    }
    ApiService.prototype.getCareerSiteData = function (careerSiteId, cultureId) {
        var headerFooterDataProvider = new CareerSiteHeaderFooterDataProvider_1.CareerSiteHeaderFooterDataProvider();
        if (csod.viewModel.isPreview) {
            return Promise.resolve(headerFooterDataProvider.mapHeaderFooterFromCareerSite({
                currentLanguage: {
                    isRightToLeft: UrlHelper_1.UrlHelper.getQueryString()['rtl'] == 'true',
                },
            }));
        }
        var url = this.baseUrl + "/v1/careersites/" + careerSiteId;
        if (cultureId) {
            url += "?cultureId=" + cultureId;
        }
        return csod.service.get(url).then(function (res) { return headerFooterDataProvider.mapHeaderFooterFromCareerSite(res.data); });
    };
    ApiService.prototype.getJobDetail = function (reqId) {
        var defaultValues = {
            displayTitle: '',
            ref: '',
            jobAd: '',
            primaryLocation: {
                title: '',
                geocode: {
                    latitude: '',
                    longitude: '',
                },
            },
            additionalLocations: [],
        };
        if (csod.viewModel.isPreview) {
            return Promise.resolve(defaultValues);
        }
        if (reqId.toString().includes('#')) {
            reqId = parseInt(reqId.toString().substring(0, reqId.toString().indexOf('#')), 10);
        }
        var url = this.requisitionBaseUrl + "/v2/requisitions/" + reqId + "/jobDetails";
        return csod.service
            .get(url)
            .then(function (response) {
            return Object.assign(defaultValues, response.data);
        })
            .catch(function (error) {
            return defaultValues;
        });
    };
    ApiService.prototype.shouldRedirectToResponsiveWorkflow = function (requisitionId) {
        var defaultValue = false;
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var url = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/jobrequisition/" + requisitionId + "/responsive";
        return csod.service
            .get(url)
            .catch(function (error) {
            return defaultValue;
        })
            .then(function (data) {
            return data.data[0];
        });
    };
    ApiService.prototype.validateWorkflowPage = function (actionsToValidate, requisitionId, page) {
        var validationResponse = new application_1.ValidatedWorkflowItems();
        if (csod.viewModel.isPreview) {
            validationResponse.isValid = true;
            return Promise.resolve(validationResponse);
        }
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/jobrequisition/" + requisitionId + "/page/" + page + "/validate?c=" + csod.viewModel.cultureID + "&careerSiteId=" + csod.viewModel.careerSiteId + "&cc=" + String(csod.viewModel.isCareerCenter);
        if (!csod.viewModel.isResumeLoaded) {
            var _a = csod.viewModel, providerId = _a.providerId, socialId = _a.socialId;
            serviceUrl += "&socialProvider=" + providerId + "&socialId=" + socialId;
        }
        return csod.service
            .post(serviceUrl, actionsToValidate, { timeout: 125000, headers: { 'Content-Type': 'text' } })
            .catch(function (error) {
            validationResponse.isValid = false;
            return validationResponse;
        })
            .then(function (data) {
            if (data.status === 500 || data.status === 400) {
                logWorkflowEndpointException('Error Validating Workflow', actionsToValidate);
            }
            validationResponse.isValid = data.data[0].isValid;
            validationResponse.validatedActions = parseValidatedActions(data.data[0].validatedActions);
            return Promise.resolve(validationResponse);
        });
    };
    ApiService.prototype.mapGetResponseData = function (data) {
        var pageResponse = new application_1.ApplicationWorkflowPage();
        pageResponse.errorResponse = Object.assign({}, data.applicationWorkflowGetErrorResponse);
        if (pageResponse.errorResponse.redirectUrl) {
            return Promise.resolve(pageResponse);
        }
        pageResponse.currentPage = data.currentPage;
        pageResponse.totalPages = data.totalPages;
        pageResponse.isCareerSiteResponsive = data.isCareerSiteResponsive;
        pageResponse.applicationId = data.applicationId;
        var actions = new Array();
        data.actions.forEach(function (element) {
            var _a;
            var elementType = application_1.ActionType[element.type];
            switch (elementType) {
                case application_1.ActionType.contactInformation:
                    var contactInfo = new application_1.ContactInfoActionItem();
                    contactInfo.id = element.actionId;
                    contactInfo.type = application_1.ActionType.contactInformation;
                    contactInfo.email = new application_2.Field();
                    contactInfo.email.value = element.email;
                    contactInfo.email.isRequired = true;
                    contactInfo.email.idTag = 'contactInfo_email';
                    contactInfo.firstName = new application_2.Field();
                    contactInfo.firstName.value = element.firstName;
                    contactInfo.firstName.isRequired = true;
                    contactInfo.firstName.idTag = 'contactInfo_firstname';
                    contactInfo.lastName = new application_2.Field();
                    contactInfo.lastName.value = element.lastName;
                    contactInfo.lastName.isRequired = true;
                    contactInfo.lastName.idTag = 'contactInfo_lastname';
                    contactInfo.services = element.availableApplyWithIntegrations;
                    actions.push(contactInfo);
                    break;
                case application_1.ActionType.interviewIntegration:
                    if (element.preferredCommunicationOptions.length < 1) {
                        break;
                    }
                    var preferredCommunicationMethod = new application_1.PreferredCommunicationActionItem();
                    preferredCommunicationMethod.id = element.actionId;
                    preferredCommunicationMethod.type = application_1.ActionType.interviewIntegration;
                    preferredCommunicationMethod.integrationType = element.integrationType;
                    preferredCommunicationMethod.preferredCommunicationOptions = new application_1.PMCDropdownField();
                    preferredCommunicationMethod.preferredCommunicationOptions.title = csod.locales.get('ATS.AppWorkflow.PreferredCommunicationMethod.Label', 'Preferred communication method for interviews');
                    preferredCommunicationMethod.preferredCommunicationOptions.idTag = 'interviewIntegration_preferredCommunicationOptions';
                    preferredCommunicationMethod.preferredCommunicationOptions.isRequired = false;
                    preferredCommunicationMethod.preferredCommunicationOptions.value = (element && element.value != null) ? element.value : null;
                    var pmcOptions = [];
                    pmcOptions.push({ label: csod.locales.get('Please Select', 'Please Select'), value: null });
                    for (var _i = 0, _b = element.preferredCommunicationOptions.sort(function (a, b) { return a.name.localeCompare(b.name); }); _i < _b.length; _i++) {
                        var pmcitem = _b[_i];
                        pmcOptions.push({ label: pmcitem.name, value: pmcitem.value });
                    }
                    preferredCommunicationMethod.preferredCommunicationOptions.items = pmcOptions;
                    actions.push(preferredCommunicationMethod);
                    break;
                case application_1.ActionType.note:
                    var note = new application_1.NoteActionItem();
                    note.id = element.actionId;
                    note.note = element.note;
                    note.instructions = element.instruction;
                    note.title = element.title;
                    note.type = application_1.ActionType.note;
                    actions.push(note);
                    break;
                case application_1.ActionType.customIntegration:
                    var customIntegration = new application_1.CustomIntegrationActionItem();
                    customIntegration.id = element.actionId;
                    customIntegration.title = element.title;
                    customIntegration.instructions = element.instruction;
                    customIntegration.isRequired = element.isRequired;
                    customIntegration.isConditionallyAdministered = element.isConditionallyAdministered;
                    customIntegration.supportRedirect = element.supportRedirect;
                    customIntegration.type = application_1.ActionType.customIntegration;
                    customIntegration.status = application_1.CustomIntegrationStatus[element.integrationStatus];
                    actions.push(customIntegration);
                    break;
                case application_1.ActionType.disclaimer:
                    var disclaimer = new application_2.DisclaimerActionItem();
                    disclaimer.id = element.actionId;
                    disclaimer.title = element.title;
                    disclaimer.instructions = element.instruction;
                    disclaimer.isYesOrNoResponse = element.inputType == 'yesOrNo';
                    disclaimer.continueIfDisagree = element.continueIfDisagree;
                    disclaimer.type = application_1.ActionType.disclaimer;
                    disclaimer.isAgreed = element.isAgreed;
                    actions.push(disclaimer);
                    break;
                case application_1.ActionType.prescreeningQuestions:
                    var prescreeningQuestion = new application_2.PrescreeningActionItem();
                    prescreeningQuestion.id = element.actionId;
                    prescreeningQuestion.title = element.title;
                    prescreeningQuestion.type = application_1.ActionType.prescreeningQuestions;
                    prescreeningQuestion.section = element.section;
                    actions.push(prescreeningQuestion);
                    break;
                case application_1.ActionType.submit:
                    var submit = new application_2.SubmitActionItem();
                    submit.id = element.actionId;
                    submit.title = element.title;
                    submit.instructions = element.instruction;
                    submit.type = application_1.ActionType.submit;
                    submit.text = element.note;
                    submit.isUserOptedIn = element.isUserOptedIn;
                    submit.isOptInVisible = element.isOptInVisible;
                    actions.push(submit);
                    break;
                case application_1.ActionType.thankYou:
                    var thankYou = new application_1.ThankYouActionItem();
                    thankYou.id = element.actionId;
                    thankYou.title = element.title;
                    thankYou.instructions = element.instruction;
                    thankYou.note = element.note;
                    thankYou.trackingPixels = element.trackingPixels;
                    thankYou.type = application_1.ActionType.thankYou;
                    actions.push(thankYou);
                    break;
                case application_1.ActionType.eeoQuestions:
                    var eeoQuestions = new application_3.EEOActionItem();
                    eeoQuestions.id = element.actionId;
                    eeoQuestions.title = element.title;
                    eeoQuestions.instructions = element.instruction;
                    for (var _c = 0, _d = element.eeoQuestions; _c < _d.length; _c++) {
                        var question = _d[_c];
                        var questionModel = new application_3.EEOQuestion();
                        questionModel = parseEEOQuestion(question);
                        eeoQuestions.eeoQuestions.push(questionModel);
                    }
                    actions.push(eeoQuestions);
                    break;
                case application_1.ActionType.resume:
                    var resume_1 = new application_1.ResumeActionItem();
                    resume_1.id = element.actionId;
                    resume_1.title = element.title;
                    resume_1.instructions = element.instruction;
                    resume_1.parsingType = element.parsingType;
                    resume_1.isRequired = element.isRequired;
                    resume_1.contactDetails = new application_1.ContactDetails();
                    resume_1.contactDetails.title = csod.locales.get('Contact Details', 'Contact Details');
                    resume_1.contactDetails.addressLine1 = new application_2.Field();
                    resume_1.contactDetails.addressLine1.title = csod.locales.get('Address Line 1', 'Address Line 1');
                    resume_1.contactDetails.addressLine1.idTag = 'contactDetails_addressLine1';
                    resume_1.contactDetails.addressLine1.isRequired = false;
                    resume_1.contactDetails.addressLine1.value = element.contactDetails.addressLine1;
                    resume_1.contactDetails.addressLine2 = new application_2.Field();
                    resume_1.contactDetails.addressLine2.title = csod.locales.get('Address Line 2', 'Address Line 2');
                    resume_1.contactDetails.addressLine2.idTag = 'contactDetails_addressLine2';
                    resume_1.contactDetails.addressLine2.isRequired = false;
                    resume_1.contactDetails.addressLine2.value = element.contactDetails.addressLine2;
                    resume_1.contactDetails.state = new application_2.Field();
                    resume_1.contactDetails.state.title = csod.locales.get('State', 'State');
                    resume_1.contactDetails.state.idTag = 'contactDetails_state';
                    resume_1.contactDetails.state.isRequired = false;
                    resume_1.contactDetails.state.value = element.contactDetails.state;
                    resume_1.contactDetails.city = new application_2.Field();
                    resume_1.contactDetails.city.title = csod.locales.get('City', 'City');
                    resume_1.contactDetails.city.idTag = 'contactDetails_city';
                    resume_1.contactDetails.city.isRequired = false;
                    resume_1.contactDetails.city.value = element.contactDetails.city;
                    resume_1.contactDetails.zipCode = new application_2.Field();
                    resume_1.contactDetails.zipCode.title = csod.locales.get('Zip Code', 'Zip Code');
                    resume_1.contactDetails.zipCode.idTag = 'contactDetails_zipCode';
                    resume_1.contactDetails.zipCode.isRequired = false;
                    resume_1.contactDetails.zipCode.value = element.contactDetails.zipCode;
                    resume_1.contactDetails.phone = new application_2.PhoneField();
                    resume_1.contactDetails.phone.title = csod.locales.get('Phone', 'Phone');
                    resume_1.contactDetails.phone.idTag = 'contactDetails_phone';
                    resume_1.contactDetails.phone.isRequired = element.contactDetails.isPhoneRequired;
                    resume_1.contactDetails.phone.isPhoneCountryCodeSelectorVisible = element.contactDetails.isPhoneCountryCodeSelectorVisible;
                    resume_1.contactDetails.phone.value = {
                        phoneNumber: element.contactDetails.phoneNumber,
                        countryCode: element.contactDetails.phoneNumberCountryCode,
                    };
                    resume_1.contactDetails.phone.countryLocalizations = [];
                    for (var _e = 0, _f = element.contactDetails.countries; _e < _f.length; _e++) {
                        var country = _f[_e];
                        resume_1.contactDetails.phone.countryLocalizations.push({
                            iso3: country.code,
                            name: country.name,
                        });
                    }
                    resume_1.contactDetails.isOptInTextMessagesVisible = !!element.contactDetails.isOptInTextMessagesVisible;
                    resume_1.contactDetails.isUserOptedInTextMessages = new application_2.Field();
                    resume_1.contactDetails.isUserOptedInTextMessages.title = csod.locales.get('Messaging.OptIn.SMS', 'Send me messages and updates about my job application via text message');
                    resume_1.contactDetails.isUserOptedInTextMessages.idTag = 'contactDetails_isUserOptedInTextMessages';
                    resume_1.contactDetails.isUserOptedInTextMessages.value = element.contactDetails.isUserOptedInTextMessages ? 'true' : 'false';
                    resume_1.contactDetails.isUserOptedInTextMessages.isRequired = false;
                    resume_1.contactDetails.isUserOptedInTextMessages.errorMessage = '';
                    resume_1.contactDetails.country = new application_2.DropdownField();
                    resume_1.contactDetails.country.title = csod.locales.get('Country', 'Country');
                    resume_1.contactDetails.country.idTag = 'contactDetails_country';
                    resume_1.contactDetails.country.isRequired = false;
                    resume_1.contactDetails.country.value = element.contactDetails.countryCode;
                    var countries = [];
                    countries.push({ label: csod.locales.get('Please Select', 'Please Select'), value: '' });
                    for (var _g = 0, _h = element.contactDetails.countries.sort(function (a, b) { return a.name.localeCompare(b.name); }); _g < _h.length; _g++) {
                        var country = _h[_g];
                        countries.push({ label: country.name, value: country.code });
                    }
                    resume_1.contactDetails.country.items = countries;
                    resume_1.resumeStructure = Object.assign({}, element.resumeStructure);
                    resume_1.resumeSourceType = element.resumeSourceType;
                    resume_1.resumeFileUploadToken = new application_2.FileUploadField();
                    if (element.recentlyUsedResume != undefined) {
                        resume_1.resumeFileUploadToken.fileUrl = element.recentlyUsedResume.path;
                        if (resume_1.resumeFileUploadToken.fileUrl[0] === '~') {
                            resume_1.resumeFileUploadToken.fileUrl = resume_1.resumeFileUploadToken.fileUrl.slice(1);
                        }
                        resume_1.resumeFileUploadToken.deleteUrl = element.recentlyUsedResume.deleteUrl;
                        resume_1.resumeFileUploadToken.title = element.recentlyUsedResume.displayName;
                        resume_1.resumeFileUploadToken.value = element.recentlyUsedResume.token;
                    }
                    csod.viewModel.isAISkillsEnable = element.isAISkillsEnable !== undefined ? element.isAISkillsEnable : false;
                    resume_1.aISkills = element.aISkills !== undefined ? element.aISkills : [];
                    if (csod.viewModel.isAISkillsEnable && ((_a = resume_1.resumeStructure) === null || _a === void 0 ? void 0 : _a.sections)) {
                        resume_1.resumeStructure.sections = resume_1.resumeStructure.sections.filter(function (section) { return section.type !== 4; });
                    }
                    resume_1.coverLetter = new application_3.CoverLetterActionItem();
                    resume_1.coverLetter.fileUploadToken = new application_2.FileUploadField();
                    if (element.coverLetter != undefined) {
                        resume_1.coverLetter.isVisible = element.coverLetter.isVisible;
                        resume_1.coverLetter.isRequired = element.coverLetter.isRequired;
                    }
                    resume_1.additionalAttachments = new Array();
                    if (element.additionalAttachments != undefined) {
                        element.additionalAttachments.forEach(function (attachment, index) {
                            var newAttachment = new application_1.AttachmentActionItem();
                            newAttachment.attachmentId = attachment.attachmentId;
                            newAttachment.index = index;
                            newAttachment.title = attachment.title;
                            newAttachment.instructions = attachment.instructions;
                            newAttachment.isRequired = attachment.isRequired;
                            newAttachment.addNewFileUpload();
                            resume_1.additionalAttachments.push(newAttachment);
                        });
                    }
                    resume_1.type = application_1.ActionType.resume;
                    actions.push(resume_1);
                    break;
            }
        });
        pageResponse.actions = actions;
        return Promise.resolve(pageResponse);
    };
    ApiService.prototype.getWorkflowPage = function (requisitionId, page, careerSiteId, providerId, socialId) {
        var _this = this;
        var defaultValues = {
            currentPage: 1,
            totalPages: 1,
            isCareerSiteResponsive: false,
            actions: new Array(),
        };
        if (csod.viewModel.isPreview) {
            if (!csod.viewModel.previewWorkflowData) {
                var previewKey = UrlHelper_1.UrlHelper.getQueryString()['previewkey'];
                csod.viewModel.previewWorkflowData = JSON.parse(window.sessionStorage.getItem('awf-preview'));
            }
            return this.mapGetResponseData(csod.viewModel.previewWorkflowData[page - 1]);
        }
        var applicantId = '';
        if (csod.viewModel.applicationId) {
            applicantId = csod.viewModel.applicationId.toString();
        }
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/jobrequisition/" + requisitionId + "/page/" + page + "?c=" + csod.viewModel.cultureID + "&careerSiteId=" + careerSiteId + "&socialProvider=" + providerId + "&socialId=" + socialId + "&applicantId=" + applicantId;
        return csod.service
            .get(serviceUrl, { timeout: 125000 })
            .catch(function (error) {
            return defaultValues;
        })
            .then(function (data) {
            return _this.mapGetResponseData(data.data[0]);
        });
    };
    ApiService.prototype.getCareerCenterWorkflowPage = function (requisitionId, page) {
        var _this = this;
        var defaultValues = {
            currentPage: 1,
            totalPages: 1,
            isCareerSiteResponsive: false,
            actions: new Array(),
        };
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/careercenter/applicationworkflow/jobrequisition/" + requisitionId + "/page/" + page + "?c=" + csod.viewModel.cultureID;
        return csod.service
            .get(serviceUrl)
            .catch(function (error) {
            return defaultValues;
        })
            .then(function (data) {
            return _this.mapGetResponseData(data.data[0]);
        });
    };
    ApiService.prototype.saveApplication = function (application, userId, requisitionId, careerSiteId, pageNum, qsParams) {
        var response = new application_3.SaveWorkflowResponse();
        response.success = false;
        if (csod.context.user < 1) {
            return Promise.reject(response);
        }
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = this.jobApplicationBaseUrl + "/user/" + userId + "/requisition/" + requisitionId;
        var requestData = Object.assign(new application_1.SaveWorkflowRequest(), {
            careerSitePageId: csod.viewModel.isCareerCenter ? null : careerSiteId,
            isCareerCenter: csod.viewModel.isCareerCenter,
            applicationResultData: JSON.stringify(application),
            page: pageNum,
        });
        if (qsParams !== null && qsParams !== undefined && qsParams.source != undefined) {
            serviceUrl = serviceUrl + "?source=" + qsParams.source;
        }
        return csod.service
            .put(serviceUrl, requestData)
            .then(function (res) {
            if (res.status === 'Success') {
                response.success = true;
                return Promise.resolve(response);
            }
            else {
                return Promise.reject(response);
            }
        })
            .catch(function (error) {
            response.error = error;
            return Promise.reject(response);
        });
    };
    ApiService.prototype.getSavedApplication = function (userId, requisitionId) {
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = this.jobApplicationBaseUrl + "/user/" + userId + "/requisition/" + requisitionId;
        var response = new application_1.SavedWorkflowResponse();
        response.isSuccessful = false;
        response.applicationResultData = [];
        if (csod.context.user < 1 || csod.viewModel.isPreview) {
            return Promise.resolve(response);
        }
        return csod.service
            .get(serviceUrl)
            .then(function (_a) {
            var data = _a.data;
            if (data && data.applicationResultData) {
                response.isSuccessful = true;
                response.applicationResultData = JSON.parse(data.applicationResultData);
                response.page = data.page;
            }
            return response;
        })
            .catch(function (error) { return response; });
    };
    ApiService.prototype.checkExternalJobApplicationCache = function (applicationId) {
        var serviceUrl = csod.context.serviceBase + "services/x/external-application/v1/job-application/cache/" + applicationId;
        var response = new application_1.SavedWorkflowResponse();
        response.isSuccessful = false;
        response.applicationResultData = [];
        return csod.service
            .get(serviceUrl)
            .then(function (_a) {
            var data = _a.data;
            if (data && data.applicationData) {
                response.isSuccessful = true;
                response.page = 1;
                response.applicationResultData = data.applicationData.map(function (d) { return (__assign(__assign({}, d), { type: d.type[0].toLowerCase() + d.type.toString().substring(1) })); });
                response.applicationResultData.forEach(function (result) {
                    if (result.type == application_1.ActionType.resume) {
                        var resumeResult = result;
                        if (resumeResult.resumeFileUploadInfo) {
                            resumeResult.resumeFileUploadInfo.fileIcon = ApplicationActions_1.getFileIconBasedFromFileType(resumeResult.resumeFileUploadInfo.title);
                        }
                        if (resumeResult.coverLetterFileUploadInfo) {
                            resumeResult.coverLetterFileUploadInfo.fileIcon = ApplicationActions_1.getFileIconBasedFromFileType(resumeResult.coverLetterFileUploadInfo.title);
                        }
                    }
                });
            }
            return response;
        })
            .catch(function (error) { return response; });
    };
    ApiService.prototype.submitApplication = function (responses, requisitionId, careerSiteId, isCareerCenter, applicationId, qsParams) {
        return __awaiter(this, void 0, Promise, function () {
            var response, serviceUrl, referralToken, referralResponse, matchedReferralToken, _a, providerId, socialId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        response = new application_3.SubmitWorkflowResponse();
                        if (csod.viewModel.isPreview) {
                            response.isValid = true;
                            response.isSuccessful = true;
                            return [2, Promise.resolve(response)];
                        }
                        if (requisitionId.toString().includes('#')) {
                            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
                        }
                        serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/jobrequisition/" + requisitionId + "?c=" + csod.viewModel.cultureID + "&cs=" + careerSiteId;
                        if (applicationId) {
                            serviceUrl = serviceUrl + "&applicationId=" + applicationId;
                        }
                        if (qsParams.jbid != undefined) {
                            serviceUrl = serviceUrl + "&jb=" + qsParams.jbid;
                        }
                        if (qsParams.m != undefined) {
                            serviceUrl = serviceUrl + "&m=" + qsParams.m;
                        }
                        if (qsParams.su != undefined) {
                            serviceUrl = serviceUrl + "&su=" + qsParams.su;
                        }
                        if (qsParams.u != undefined) {
                            serviceUrl = serviceUrl + "&ru=" + qsParams.u;
                        }
                        if (qsParams.cc != undefined) {
                            serviceUrl = serviceUrl + "&cc=" + qsParams.cc;
                        }
                        else if (isCareerCenter) {
                            serviceUrl = serviceUrl + "&cc=true";
                        }
                        if (qsParams.source != undefined) {
                            serviceUrl = serviceUrl + "&s=" + qsParams.source;
                        }
                        if (!(csod.viewModel.isICSReferralsOn === 'true')) return [3, 2];
                        referralToken = ReferralTokenHelper_1.getReferralTokenFromPage();
                        return [4, this.validateReferral(csod.viewModel.email, referralToken, requisitionId)];
                    case 1:
                        referralResponse = _b.sent();
                        matchedReferralToken = referralResponse === null || referralResponse === void 0 ? void 0 : referralResponse.referralToken;
                        serviceUrl = matchedReferralToken ? serviceUrl + "&referralToken=" + matchedReferralToken : serviceUrl;
                        _b.label = 2;
                    case 2:
                        if (!csod.viewModel.isResumeLoaded) {
                            _a = csod.viewModel, providerId = _a.providerId, socialId = _a.socialId;
                            serviceUrl += "&socialProvider=" + providerId + "&socialId=" + socialId;
                        }
                        return [2, csod.service
                                .post(serviceUrl, responses, { timeout: 125000, headers: { 'Content-Type': 'text' } })
                                .catch(function (error) {
                                response.isValid = true;
                                response.isSuccessful = false;
                                return response;
                            })
                                .then(function (data) {
                                if (data.status === 500 || data.status === 400) {
                                    logWorkflowEndpointException('Error Submitting Workflow', responses);
                                }
                                response.isValid = data.data[0].isValid;
                                response.isSuccessful = data.data[0].isSuccessful;
                                response.errorMessage = data.data[0].errorMessage;
                                response.createProfileURL = data.data[0].createProfileURL;
                                response.validatedActions = parseValidatedActions(data.data[0].validatedActions);
                                response.applicationId = data.data[0].applicantId;
                                response.userId = data.data[0].userId;
                                return Promise.resolve(response);
                            })];
                }
            });
        });
    };
    ApiService.prototype.validateReferral = function (email, referralToken, reqId) {
        var url = 'rec-referral-api/referrals/validate';
        var requestData = {
            referralToken: referralToken,
            email: email,
            reqId: Number(reqId),
        };
        return csod.service.cloud
            .post(url, requestData)
            .then(function (response) {
            return Promise.resolve(response.data);
        })
            .catch(function (error) {
            csod.logger.error("Error occured while validating referral for email " + email + " with referral token " + referralToken + ":" + error);
            return null;
        });
    };
    ApiService.prototype.getCorpSettingValue = function (key) {
        var corpSettingsServiceUrl = this.corpSettingsBaseUrl + "/v1/corpsettings/" + key;
        return csod.service
            .get(corpSettingsServiceUrl)
            .then(function (response) {
            if (response.data) {
                return response.data.value;
            }
            return '';
        })
            .catch(function (error) {
            csod.logger.error("Error occured while fetching " + key + " corp setting value:" + error);
            return '';
        });
    };
    ApiService.prototype.validateAnonymousEmail = function (email, requisitionId) {
        var validationResponse = new application_3.ValidateAnonymousEmailResponse();
        if (csod.viewModel.isPreview) {
            return Promise.resolve(validationResponse);
        }
        if (requisitionId.toString().includes('#')) {
            requisitionId = parseInt(requisitionId.toString().substring(0, requisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/ApplyAsGuest/ValidateAnonymousEmail?email=" + email + "&jobRequisitionId=" + requisitionId + "&c=" + csod.viewModel.cultureID + "&corp=" + csod.context.corp;
        return csod.service
            .get(serviceUrl)
            .then(function (data) {
            validationResponse.statusCode = data.data[0].statusCode;
            validationResponse.validationMessage = data.data[0].validationMessage;
            return validationResponse;
        })
            .catch(function (error) {
            return validationResponse;
        });
    };
    ApiService.prototype.getApplyWithAuthUrl = function (providerId, redirectUrl, careerSiteId, jobReqId) {
        var defaultValues = {
            authURL: '',
        };
        if (jobReqId.toString().includes('#')) {
            jobReqId = parseInt(jobReqId.toString().substring(0, jobReqId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/ApplyWithIntegration/GetAuthUrl?provider=" + providerId + "&redirectUrl=" + redirectUrl + "&careerSiteId=" + careerSiteId + "&jobReqId=" + jobReqId;
        return csod.service
            .get(serviceUrl)
            .then(function (data) {
            return Object.assign(defaultValues, data.data[0]);
        })
            .catch(function (error) {
            return defaultValues;
        });
    };
    ApiService.prototype.getResolvedTags = function (requestData) {
        var serviceUrl = "rec-app-workflow-tags-resolver/v1/ThankYou";
        var defaultMessage = null;
        return csod.service.cloud
            .post(serviceUrl, requestData)
            .then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            csod.logger.error('Unable to resolve the tags: ' + error);
            return defaultMessage;
        });
    };
    ApiService.prototype.deleteAttachments = function (tokens) {
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/attachments/delete";
        csod.service.put(serviceUrl, tokens).catch(function (error) {
            csod.logger.error('DeleteAttachmentsError: Error in deleting token(s): ' + tokens.join(', '));
        });
    };
    ApiService.prototype.saveWorkflowAttachments = function (tokens) {
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/attachments/save";
        csod.service.post(serviceUrl, tokens);
    };
    ApiService.prototype.restoreWorkflowAttachments = function (tokens) {
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS//applicationworkflow/attachments/restore";
        csod.service.post(serviceUrl, tokens);
    };
    ApiService.prototype.getResumeDataByUrl = function (url, postData) {
        if (postData === void 0) { postData = {}; }
        var defaultValues = {
            contactDetails: null,
            resumeStructure: null,
            aISkills: [],
        };
        return csod.service
            .post(url, postData, { headers: { 'Content-Type': 'text' } })
            .then(function (data) {
            var parsedResume = new application_3.ParseResumeResponse();
            if (data.data.length >= 0) {
                var _a = data.data[0], contactDetails = _a.contactDetails, resumeStructureModel = _a.resumeStructureModel, aISkills = _a.aISkills;
                parsedResume.contactDetails = new application_1.ContactDetails();
                parsedResume.contactDetails.addressLine1 = new application_2.Field();
                parsedResume.contactDetails.addressLine1.value = contactDetails.addressLine1;
                parsedResume.contactDetails.addressLine2 = new application_2.Field();
                parsedResume.contactDetails.addressLine2.value = contactDetails.addressLine2;
                parsedResume.contactDetails.state = new application_2.Field();
                parsedResume.contactDetails.state.value = contactDetails.state;
                parsedResume.contactDetails.city = new application_2.Field();
                parsedResume.contactDetails.city.value = contactDetails.city;
                parsedResume.contactDetails.zipCode = new application_2.Field();
                parsedResume.contactDetails.zipCode.value = contactDetails.zipCode;
                parsedResume.contactDetails.phone = new application_2.PhoneField();
                parsedResume.contactDetails.phone.value = {
                    phoneNumber: contactDetails.phoneNumber,
                    countryCode: contactDetails.phoneNumberCountryCode,
                };
                parsedResume.contactDetails.country = new application_2.DropdownField();
                parsedResume.contactDetails.country.value = contactDetails.countryCode;
                parsedResume.resumeStructure = Object.assign({}, resumeStructureModel);
                parsedResume.aISkills = aISkills;
            }
            return parsedResume;
        })
            .catch(function (error) {
            return defaultValues;
        });
    };
    ApiService.prototype.parseResume = function (resumeFileUploadToken, parsingType) {
        var _a;
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/Resume/ParseResumeDocument?fileToken=" + resumeFileUploadToken + "&parsingType=" + parsingType + "&cultureId=" + csod.viewModel.cultureID + "&isAISkillenabled=" + ((_a = csod.viewModel) === null || _a === void 0 ? void 0 : _a.isAISkillsEnable);
        return this.getResumeDataByUrl(serviceUrl);
    };
    ApiService.prototype.getKeywordPredictiveSearchResults = function (searchRequest) {
        var graphqlEndpoint = 'perf-capability-api/v1/graphql';
        var payload = {
            operationName: 'CapabilityElasticSearch',
            query: "\n                query CapabilityElasticSearch($elasticSearchRequest: ElasticSearchInputType) {\n                    searchCapabilities(elasticSearchRequest: $elasticSearchRequest) {\n                        pagedResult {\n                            ... on SkillType {\n                                id\n                                name\n                                externalId\n                                source\n                                skillsGraphId\n                            }\n                            ... on CompetencyType {\n                                id\n                                name\n                                externalId\n                                source\n                                skillsGraphId\n                            }\n                        }\n                    }\n                }\n            ",
            variables: {
                elasticSearchRequest: {
                    capabilityTypes: ['Skill'],
                    context: 'CAPABILITY_ONLY',
                    fetchDeletedCapabilityFromSkillsGraph: false,
                    searchTerm: searchRequest.searchText
                }
            }
        };
        return csod.service.cloud.post(graphqlEndpoint, payload, { headers: { 'x-csod-default-culture-name': csod.context.cultureName } }).then(function (response) {
            return response.data;
        })
            .catch(function (error) {
            csod.logger.error('Error fetching skills: ' + JSON.stringify(error));
            return {
                searchCapabilities: {
                    pagedResult: []
                }
            };
        });
    };
    ApiService.prototype.convertSocialNetworkData = function (socialProviderId, postData) {
        var _a;
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/resume/mapdata?socialProviderId=" + socialProviderId + "&cultureId=" + csod.viewModel.cultureID + "&isAISkillenabled=" + ((_a = csod.viewModel) === null || _a === void 0 ? void 0 : _a.isAISkillsEnable);
        return this.getResumeDataByUrl(serviceUrl, postData);
    };
    ApiService.prototype.launchCustomIntegration = function (actionId, jobRequisitionId, cultureId, jobApplicationId, careerSiteId, isCareerCenter, email, firstName, lastName, contactDetails, redirectUrl, qsParams) {
        var response = new application_1.LaunchCustomIntegrationResponse();
        if (jobRequisitionId.toString().includes('#')) {
            jobRequisitionId = parseInt(jobRequisitionId.toString().substring(0, jobRequisitionId.toString().indexOf('#')), 10);
        }
        var serviceUrl = csod.context.serviceBase + "Services/API/ATS/applicationworkflow/jobrequisition/" + jobRequisitionId + "/customintegration/" + actionId + "/launch?c=" + cultureId;
        var requestData = new application_1.LaunchCustomIntegrationRequest();
        requestData.jobApplicationId = jobApplicationId || null;
        requestData.careerSiteId = careerSiteId;
        requestData.email = email;
        requestData.firstName = firstName;
        requestData.lastName = lastName;
        requestData.contactDetails = contactDetails;
        requestData.isCareerCenter = qsParams.cc || isCareerCenter || false;
        requestData.jobBoardId = qsParams.jbid || 0;
        requestData.referralMethod = qsParams.m || null;
        requestData.referralSuggestedUserId = qsParams.su || null;
        requestData.referralUserId = qsParams.u || null;
        requestData.source = qsParams.source || '';
        requestData.redirectUrl = redirectUrl;
        return csod.service
            .post(serviceUrl, requestData, { headers: { 'Content-Type': 'text' } })
            .then(function (res) {
            response.launchURL = res.data[0].launchURL;
            if (response.launchURL[0] === '~') {
                response.launchURL = response.launchURL.slice(1);
            }
            response.jobApplicationId = res.data[0].jobApplicationId;
            response.integrationOrderId = res.data[0].integrationOrderId;
            response.errorMessage = res.data[0].errorMessage;
            return Promise.resolve(response);
        })
            .catch(function (error) {
            return Promise.reject(response);
        });
    };
    return ApiService;
}());
exports.ApiService = ApiService;
var parseValidatedActions = function (validatedActions) {
    var validations = new Array();
    validatedActions.forEach(function (element) {
        var elementType = application_1.ActionType[element.type];
        switch (elementType) {
            case application_1.ActionType.contactInformation:
                var validatedContactInfo = new application_2.ValidatedContactInfoAction();
                validatedContactInfo.actionId = element.actionId;
                validatedContactInfo.isValid = element.isValid;
                for (var _i = 0, _a = element.errors; _i < _a.length; _i++) {
                    var error = _a[_i];
                    var validation = new application_3.ValidationError();
                    validation.message = error.message;
                    validation.path = error.path;
                    validatedContactInfo.errors.push(validation);
                }
                validations.push(validatedContactInfo);
                break;
            case application_1.ActionType.interviewIntegration:
                var validatedPreferredCommunication = new application_1.ValidatedPreferredCommunicationAction();
                validatedPreferredCommunication.actionId = element.actionId;
                validatedPreferredCommunication.isValid = element.isValid;
                for (var _b = 0, _c = element.errors; _b < _c.length; _b++) {
                    var error = _c[_b];
                    var validation = new application_3.ValidationError();
                    validation.message = error.message;
                    validation.path = error.path;
                    validatedPreferredCommunication.errors.push(validation);
                }
                validations.push(validatedPreferredCommunication);
                break;
            case application_1.ActionType.disclaimer:
                var validatedDisclaimer = new application_2.ValidatedDisclaimerAction();
                validatedDisclaimer.actionId = element.actionId;
                validatedDisclaimer.isValid = element.isValid;
                validatedDisclaimer.errorMessage = element.errorMessage;
                validations.push(validatedDisclaimer);
                break;
            case application_1.ActionType.prescreeningQuestions:
                var validatedPrescreening = new application_2.ValidatedPrescreeningAction();
                validatedPrescreening.actionId = element.actionId;
                validatedPrescreening.isValid = element.isValid;
                validatedPrescreening.errors = element.errors;
                validations.push(validatedPrescreening);
                break;
            case application_1.ActionType.eeoQuestions:
                var validatedEEOQuestions = new application_3.ValidatedEEOQuestionsAction();
                validatedEEOQuestions.actionId = element.actionId;
                validatedEEOQuestions.isValid = element.isValid;
                for (var _d = 0, _e = element.errors; _d < _e.length; _d++) {
                    var error = _e[_d];
                    var validation = new application_3.ValidationError();
                    validation.message = error.message;
                    validation.path = error.path;
                    validatedEEOQuestions.errors.push(validation);
                }
                validations.push(validatedEEOQuestions);
                break;
            case application_1.ActionType.resume:
                var validatedResume = new application_3.ValidatedResumeAction();
                validatedResume.actionId = element.actionId;
                validatedResume.isValid = element.isValid;
                for (var _f = 0, _g = element.errors; _f < _g.length; _f++) {
                    var error = _g[_f];
                    var validation = new application_3.ValidationError();
                    validation.message = error.message;
                    validation.path = error.path;
                    validatedResume.errors.push(validation);
                }
                validations.push(validatedResume);
                break;
            case application_1.ActionType.customIntegration:
                var validatedCustomIntegration = new application_1.ValidatedCustomIntegrationAction();
                validatedCustomIntegration.actionId = element.actionId;
                validatedCustomIntegration.isValid = element.isValid;
                validatedCustomIntegration.errorMessage = element.errorMessage;
                validations.push(validatedCustomIntegration);
                break;
        }
    });
    return validations;
};
var getEEOLabel = function (questionModel) {
    var label = '';
    if (csod.viewModel.isTMNTApril2021Enabled) {
        switch (questionModel.id) {
            case -3:
            case -1:
                label = csod.locales.get('Voluntary Self-Identification of Disability', 'Voluntary Self-Identification of Disability') + ':';
                break;
            case 7:
                label =
                    csod.locales.get('sqldb.eeo_question_local.eeo_question_id.7.question_label', 'Please select your Veteran Status (Part 60-300)') +
                        ':';
                break;
            case -2:
                label =
                    csod.locales.get('sqldb.eeo_question_local.eeo_question_id.-2.question_label', 'Please select your Veteran Status (VETS-4212)') +
                        ':';
                break;
            default:
                label = questionModel.text;
                break;
        }
    }
    else {
        if (questionModel.id === -3 || questionModel.id === -1 || questionModel.id == 7 || questionModel.id == -2) {
            label = csod.locales.get('Please select a response', 'Please select a response');
        }
        else {
            label = questionModel.text;
        }
    }
    return label;
};
var parseEEOQuestion = function (question) {
    var questionModel = new application_3.EEOQuestion();
    questionModel.id = question.id;
    questionModel.text = question.text;
    questionModel.isRequired = question.isRequired;
    questionModel.tag = "EEOQuestion-" + question.id;
    questionModel.errorMessageTag = "EEOQuestion-ErrorMessage-" + question.id;
    questionModel.selectedResponse = question.selectedResponse;
    questionModel.displayFolloUpQuestion = question.selectedResponse == question.followUpResponseId;
    questionModel.errorMessage = '';
    questionModel.isHtml = questionModel.id === -3 || questionModel.id == 7 || questionModel.id == -2;
    questionModel.label = getEEOLabel(questionModel);
    var responseModel = new application_3.EEOResponse();
    responseModel.value = 0;
    responseModel.label = csod.locales.get('Please Select', 'Please Select');
    questionModel.responses.push(responseModel);
    for (var _i = 0, _a = question.responses; _i < _a.length; _i++) {
        var response = _a[_i];
        var responseModel_1 = new application_3.EEOResponse();
        responseModel_1.value = response.id;
        responseModel_1.label = response.text;
        questionModel.responses.push(responseModel_1);
    }
    if (question.followUpResponseId != undefined) {
        questionModel.followUpResponseId = question.followUpResponseId;
    }
    if (question.followUpEeoQuestion != undefined) {
        questionModel.followUpEeoQuestion = parseEEOQuestion(question.followUpEeoQuestion);
    }
    else {
        questionModel.followUpEeoQuestion = new application_3.EEOQuestion();
        questionModel.followUpEeoQuestion.id = 0;
        questionModel.followUpEeoQuestion.responses = new Array();
    }
    return questionModel;
};
var logWorkflowEndpointException = function (message, responses) {
    var results = JSON.stringify(responses);
    var reqId = csod.viewModel.reqId;
    var corp = csod.context.corp;
    csod.logger.error({ message: message, results: results, reqId: reqId, corp: corp });
};



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/api/index.ts
// module id = 146
// module chunks = 0 2